// extracted by mini-css-extract-plugin
export var tagFill = "wGyvL";
export var tagOutline = "QMOfe";
export var tagWrapper = "lvhUc";